import { DEFAULT_SORT, SEO_SENSITIVE_FILTERS } from 'config/constants';
import { LOAD_MORE_QUERY_PARAMETER_NAME, PAGE_QUERY_PARAMETER_NAME, SORT_QUERY_PARAMETER_NAME } from 'config/constants';
import { ProductOrderingModeEnumApi } from 'graphql/generated';
import { buildNewQueryAfterFilterChange } from 'helpers/filterOptions/buildNewQueryAfterFilterChange';
import { getFilterWithoutEmpty } from 'helpers/filterOptions/getFilterWithoutEmpty';
import { getQueryWithoutSlugTypeParameterFromParsedUrlQuery } from 'helpers/parsing/urlParsing';
import { pushQueries } from 'helpers/queryParams/pushQueries';
import { useCurrentFilterQuery } from 'helpers/queryParams/useCurrentFilterQuery';
import { useRouter } from 'next/router';
import { useSessionStore } from 'store/useSessionStore';
import { UrlQueries } from 'types/urlQueries';
import { getChangedDefaultFilters, useRedirectFromSeoCategory } from 'utils/seoCategories/queryParamsUtils';

export const useUpdateSortQuery = () => {
    const router = useRouter();
    const query = getQueryWithoutSlugTypeParameterFromParsedUrlQuery(router.query) as UrlQueries;
    const currentFilter = useCurrentFilterQuery();
    const defaultProductFiltersMap = useSessionStore((s) => s.defaultProductFiltersMap);
    const originalCategorySlug = useSessionStore((s) => s.originalCategorySlug);
    const redirectFromSeoCategory = useRedirectFromSeoCategory();

    const updateSortQuery = (sorting: ProductOrderingModeEnumApi) => {
        if (SEO_SENSITIVE_FILTERS.SORT && originalCategorySlug) {
            redirectFromSeoCategory(() => {
                const newQuery = buildNewQueryAfterFilterChange(
                    query,
                    getFilterWithoutEmpty(getChangedDefaultFilters(defaultProductFiltersMap, currentFilter)),
                    sorting,
                );

                pushQueries(router, newQuery, true, originalCategorySlug);
            });

            return;
        }

        pushQuerySort(sorting);
    };

    const pushQuerySort = (sorting: ProductOrderingModeEnumApi) => {
        const newQuery: UrlQueries = {
            ...query,
            [LOAD_MORE_QUERY_PARAMETER_NAME]: undefined,
            [PAGE_QUERY_PARAMETER_NAME]: undefined,
            [SORT_QUERY_PARAMETER_NAME]: sorting !== DEFAULT_SORT ? sorting : undefined,
        } as const;

        pushQueries(router, newQuery, true);
    };

    return updateSortQuery;
};
